import { VehicleValuationValidity } from "@/api-schema-enums";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

const VEHICLE_VALUATION_VALIDITY_OPTIONS: { id: VehicleValuationValidity; name: string }[] = [
  { id: VehicleValuationValidity.Valid, name: "fab:ValuationValidityValid" },
  { id: VehicleValuationValidity.Invalid, name: "fab:ValuationValidityInvalid" },
];

export class VehicleValuationValidityFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id: string = "validities";
  readonly labelSingular = "fab:ValuationValidity";
  readonly labelPlural = "fab:ValuationValidity";
  readonly placeholder = "fab:SelectValuationValidity";
  readonly searchPlaceholder = "fab:SearchValuationValidity";
  readonly emptyText = "fab:NoValuationValidityFound";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return {
      options: VEHICLE_VALUATION_VALIDITY_OPTIONS,
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
